import { render, staticRenderFns } from "./MailEditSend.vue?vue&type=template&id=49695b58&lang=pug&"
import script from "./MailEditSend.vue?vue&type=script&lang=ts&"
export * from "./MailEditSend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports